import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { STATUS } from 'src/app/enums/status.enum';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';

const $ = window as any;

@Component({
  selector: 'app-mobile-payment',
  templateUrl: './mobile-payment.component.html',
  styleUrls: ['./mobile-payment.component.scss']
})
export class MobilePaymentComponent implements OnInit {
  token: string = '';
  order_id: string = '';
  paymentData: { [key: string]: any };
  paymentForm: { [key: string]: any };

  constructor(private utilityService: UtilityService,
    private apiService: ApiService,
    private route: ActivatedRoute) {

    this.route.params.subscribe((event: any) => {
      this.order_id = event.id;
    });

    route.queryParams.subscribe(data => {
      this.token = data.token;
    });
  }

  ngOnInit(): void {
    console.log("test");

    this.apiService.submitOrderForMobile(this.order_id, this.token).subscribe((res: any) => {
      console.log(res);
      let submit_data: any = {
        order_id: this.order_id,
        bank_name: "ABA"
      };

      this.apiService.paymentDATAForMobile(submit_data, this.token).subscribe(response => {

        console.log(response);
        
        if (response.status != STATUS.SUCCESS) {
          return;
        }

        // SAVE ORDER ID FOR REDIRECT
        let payment_action_url: string = response.payment.action_url;
        this.paymentData = response.payment;
        this.paymentForm = response.payment;
        delete this.paymentForm.action_url;

        this.paymentData.action_url = payment_action_url;

        // POPUP CHECKOUT
        setTimeout($.AbaPayway.checkout, 0);
      })
    });
  }
}
